<template>
  <img class="box-img" :src="msg.imgURL" @click="$emit('remix', { msg })" alt="">
</template>

<script>
export default {
  props: {
    msg: {}
  },
  methods: {
    getURL () {
      let msg = this.msg
      if (msg.imgBucket && msg.imgUUID && msg.imgExt) {
        return `https://${msg.imgBucket}.s3.amazonaws.com/${msg.imgUUID}.${msg.imgExt}`
      } else {
        return msg.url
      }
    },
    getBoxStyle ({ el }) {
      let msg = this.msg
      let aspect = 1
      // let size = 50
      if (msg.imgWidth && msg.imgHeight) {
        aspect = msg.imgHeight / msg.imgWidth
      }
      let rect = el.getBoundingClientRect()
      return {
        display: 'inline-block',
        width: 100 + '%',
        get height () {
          return (rect.width * aspect) + 'px'
        }
      }
    }
  }
}
</script>

<style scoped>
  .box-img{
    border-radius: 9px;
    width: 100%;
  }
</style>
